import { render } from "./IconError.vue?vue&type=template&id=216493aa"
import script from "./IconError.vue?vue&type=script&lang=js"
export * from "./IconError.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__